import { useI18n } from 'vue-i18n'

export const VEHICLE_TYPE_NAME_VALUES = {
  FLATBED: 'Flatbed',
  CLOSED_VAN: 'Closed van',
  PICKUP_TRUCK: 'Pick-up truck',
} as const

const VEHICLE_TYPE_NAME_TRANSLATION_KEYS: Record<string, string> = {
  [VEHICLE_TYPE_NAME_VALUES.FLATBED]: 'vehicleTypeNameFlatbed',
  [VEHICLE_TYPE_NAME_VALUES.CLOSED_VAN]: 'vehicleTypeNameClosedVan',
  [VEHICLE_TYPE_NAME_VALUES.PICKUP_TRUCK]: 'vehicleTypeNamePickupTruck',
}

export function useVehicleTypeNames() {
  const { t } = useI18n()

  const vehicleTypeNameOptions = Object.values(VEHICLE_TYPE_NAME_VALUES).map((value) => ({
    title: t(VEHICLE_TYPE_NAME_TRANSLATION_KEYS[value]),
    value,
  }))

  const translateVehicleTypeName = (value: string | null | undefined) => {
    if (!value) {
      return value
    }
    const key = VEHICLE_TYPE_NAME_TRANSLATION_KEYS[value]
    return key ? t(key) : value
  }

  return { vehicleTypeNameOptions, translateVehicleTypeName }
}
